import introRouter from './intro.router.js'
import appRouter from './app.router.js'
import protocolRouter from './protocol.router'
import newrainbowRouter from './newrainbow.router'
import sanbiaoRouter from './sanbiao.router'
import bianxianRouter from './bianxian.router'
import fundRouter from './fund.router'
import assetRouter from './asset.router'
import yearBillRouter from './yearbill.router'
import landingRouter from './landing.router'

export default [
    ...introRouter,
    ...appRouter,
    ...protocolRouter,
    ...newrainbowRouter,
    ...sanbiaoRouter,
    ...bianxianRouter,
    ...fundRouter,
    ...assetRouter,
    ...yearBillRouter,
  ...landingRouter
]
